import { CommentType } from "lib/domain/comments/CommentAnalytics";
import { SentimentRating } from "types/Result";

export default {
	globalAttributeName: "Entire Organization",
	segment: "Segment",
	percent: "Percent",
	btnChangeLanguage: "Change language",
	copied: "Copied to clipboard",
	languages: {
		german: "German",
		de: "German",
		english: "English",
		en: "English",
		russian: "Russian",
		ru: "Russian",
		pl: "Polish",
		polish: "Polish",
		tr: "Turkish",
		ro: "Romanian",
		cs: "Czech",
		zh: "Chinese (China)",
		es: "Spanish",
		da: "Danish",
		fr: "French",
		ja: "Japanese",
		fi: "Finnish",
		hu: "Hungarian",
		sv: "Swedish",
		lt: "Lithuanian",
		bg: "Bulgarian",
		uk: "Ukrainian",
		it: "Italian",
		bs: "Bosnian",
		sl: "Slovenian",
		hr: "Croatian",
		ar: "Arabic",
		el: "Greek",
		pt: "Portuguese",
		sq: "Albanian",
		ms: "Malay",
		fa: "Persian",
		ku: "Kurdish",
		sr: "Serbian",
	},
	saveAsImage: "Als Bild speichern",
	sentiment: {
		[SentimentRating.neutral]: "Neutral",
		[SentimentRating.mixed]: "Mixed",
		[SentimentRating.negative]: "Negative",
		[SentimentRating.veryNegative]: "Very Negative",
		[SentimentRating.positive]: "Positive",
		[SentimentRating.veryPositive]: "Very Positive",
	},
	commentType: {
		[CommentType.idea]: "Suggestion",
		[CommentType.praise]: "Praise",
		[CommentType.critic]: "Criticism",
		[CommentType.sensitive]: "Sensitive",
		[CommentType.other]: "Other",
	},
	threshold: "Threshold",
	roles: {
		admin: "Administrator",
		user: "User",
		"user-editor": "User editor",
		"peer-feedback-user": "Peer feedback user",
		"read-all-reports": "Grant access to all reports",
		"access-all-data": "Access all data",
	},
	roleDescriptions: {
		admin: "Full access to Kultify",
		user: "Access to the user area of the Kultify",
		"user-editor": "Can manage the users and see all attributes and segments",
		"peer-feedback-user": "Can create and view peer feedback",
		"read-all-reports": "Can view all reports",
		"access-all-data": "Can access all data in reports accessible to the user.",
	},
	groupBy: {
		round: "Round",
		week: "Week",
		month: "Month",
		day: "Day",
		quarter: "Quarter",
		year: "Year",
	},
	roundDate: {
		round: "{{date, D}}",
		today: "Today",
		day: "{{date, D}}",
		week: "{{date, MM/y 'CW'W+useTZ}}",
		month: "{{date, LL/y+useTZ}}",
		quarter: "{{date, q'.Quarter' y+useTZ}}",
		year: "{{date, y+useTZ}}",
	},
	btnClear: "Clear",
	bool: {
		true: "True",
		false: "False",
	},
	reportTypes: {
		benchmark: "Benchmark",
		"data-set": "Dataset",
		detail: "Detail",
	},
	keyboardShortcut: "Keyboard shortcut: {{shortcut}}",
	generatedByAI: "Generated by AI",
	resultIdAllowedCharsHelper: "Allowed characters: a-z, A-Z, 0-9, -, _",
	nps: {
		title: "Engagement Score",
		scoreTooltip:
			"Engagement Score: Percentage of promoters - percentage of detractors",
	},
	areas: {
		myArea: "My Area",
		administration: "Administration",
		organization: "Organization",
	},

	learn_mode: "Learn more",
	copy: "Copy",
	search: "Search...",
};
